module.exports = "<div ng-if=\"isSpinnerVisible\">\n    <div class=\"inner-wrap paddedx2\">\n        <span us-spinner=\"{radius:30, width:8, length: 16}\" spinner-key=\"spinner-1\" spinner-start-active=\"true\"></span>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/common/loadingSpinner.html
// module id = 207
// module chunks = 0